import { useMemo } from 'react';
import { useLoanApplication } from '@axo/shared/data-access/hooks';
import { AceCardSection } from '../AceCard';
import { PaymentRemarkTag } from './PaymentRemarkTag/PaymentRemarkTag';
import styles from './PaymentRemarkSection.module.css';

interface IPaymentRemarkSection {
  applicationID: string;
  personID: string;
}

export function SectionDK({ applicationID, personID }: IPaymentRemarkSection) {
  const { data: app } = useLoanApplication(applicationID);

  const remarks = useMemo(() => {
    if (app?.PaymentRemarks === null || app?.PaymentRemarks === undefined) {
      return undefined;
    }

    if (app.PaymentRemarks) {
      return 'yes';
    }

    return 0;
  }, [app?.PaymentRemarks]);

  return (
    <AceCardSection
      id={`PaymentRemark.${personID}`}
      title={<span className={styles.title}>Payment remarks</span>}
      tag={<PaymentRemarkTag numberOfRemarks={remarks} />}
    >
      {remarks === undefined
        ? 'Payment remark status has not been set'
        : remarks === 'yes'
          ? 'This person has payment remarks'
          : 'This person has no payment remarks'}
    </AceCardSection>
  );
}
